import { Pipe, PipeTransform } from '@angular/core';
import { TranslatePipe } from '../../pipes/translate/translate.pipe';
import { IMitsTableColumn } from './../interfaces/mits-table-column';

@Pipe({ name: 'getValue' })
/**
 * Gets the Value of an MitsTable Dataset
 */
export class GetValuePipe implements PipeTransform {
  constructor(private readonly translatePipe: TranslatePipe<any>) {}

  /**
   * Extrahiert aus einem Datensatz den Wert
   * @param {any} dataItem
   * @param {IMitsTableColumn} columnInfo
   * @returns {any}
   */
  transform(dataItem: any, columnInfo: IMitsTableColumn | string): any {
    if (!dataItem || !columnInfo) {
      return '';
    }
    const paramsStr =
      typeof columnInfo === 'string' ? columnInfo : columnInfo.name;
    // Objekt-Übersetzung: übersetzt den Wert des Datensatzes in die aktuelle Sprache
    // (Fallback aufs Basisfeld). Nur für einfache (nicht verschachtelte) Spalten.
    if (
      typeof columnInfo !== 'string' &&
      columnInfo.translatable &&
      !paramsStr.includes('.') &&
      Array.isArray(dataItem.translations)
    ) {
      return this.translatePipe.transform(dataItem, paramsStr);
    }
    if (!paramsStr.includes('.')) {
      return this.translate(dataItem[paramsStr], columnInfo);
    }
    const foundKeys = paramsStr.split('.', 100);
    let currentValue = dataItem;
    while (foundKeys.length > 0) {
      if (!currentValue) {
        return '';
      }
      currentValue = currentValue[foundKeys[0]];
      foundKeys.shift();
    }
    return this.translate(currentValue, columnInfo);
  }

  /**
   * Übersetzt einen Wert
   * @param {string} value
   * @param {IMitsTableColumn} columnInfo
   * @return {string}
   */
  private translate(
    value: string,
    columnInfo?: IMitsTableColumn | string
  ): string {
    if (typeof columnInfo !== 'string' && columnInfo?.translations) {
      return columnInfo.translations[value];
    } else {
      return value;
    }
  }
}
